export default __webpack_public_path__ + "static/media/halden.6a24dd8f.gif";